export default __webpack_public_path__ + "static/media/form_1.50b3e3e9.jpg";